import * as DialogPrimitive from '@radix-ui/react-dialog';
import { RiCloseLine } from 'react-icons/ri';

import { Dialog, DialogOverlay, DialogPortal, DialogTitle } from '@/components/ui/dialog';
import { useGenerationInfoStore } from '@/music/hooks/use-generation-info-store';

export const GenerationInfoSheet = () => {
  const track = useGenerationInfoStore((state) => state.track);
  const isOpen = useGenerationInfoStore((state) => state.isOpen);
  const close = useGenerationInfoStore((state) => state.close);

  if (!track?.generation) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && close()}>
      <DialogPortal>
        <DialogOverlay className="bg-black/40" />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          className="data-[state=open]:animate-in data-[state=open]:slide-in-from-bottom data-[state=closed]:animate-out data-[state=closed]:slide-out-to-bottom fixed inset-x-0 bottom-0 z-50 mx-auto flex max-h-[70dvh] w-full max-w-3xl flex-col rounded-t-2xl border bg-white duration-300 outline-none motion-reduce:animate-none"
        >
          <div className="bg-border mx-auto mt-3 h-1 w-10 shrink-0 rounded-full" />
          <div className="flex items-center justify-between gap-3 px-6 pt-3 pb-2">
            <DialogTitle className="truncate text-base">{track.title}</DialogTitle>
            <DialogPrimitive.Close
              aria-label="닫기"
              className="text-muted-foreground hover:bg-accent hover:text-foreground flex size-8 shrink-0 items-center justify-center rounded-lg transition-colors"
            >
              <RiCloseLine className="text-lg" />
            </DialogPrimitive.Close>
          </div>
          <div className="flex flex-col gap-4 overflow-y-auto px-6 pb-8">
            <section>
              <h3 className="text-muted-foreground mb-1 text-xs font-medium">프롬프트</h3>
              <p className="text-sm">{track.generation.prompt}</p>
            </section>
            {track.generation.lyrics && (
              <section>
                <h3 className="text-muted-foreground mb-1 text-xs font-medium">가사</h3>
                <p className="text-sm leading-relaxed whitespace-pre-line">
                  {track.generation.lyrics}
                </p>
              </section>
            )}
          </div>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>
  );
};
